import {
  CAT_CONTACTS,
  CAT_PATENTS,
  CAT_SAMPLES,
  CAT_PRODUCTS,
  CAT_BRANDS,
  CAT_COMPANIES,
  CAT_TRADEMARKS,
  CAT_STANDING_REPORTS,
  CAT_PATENT_RESEARCH,
  CAT_COMPONENTS,
  CAT_FILES,
  CAT_NEWS,
  CAT_CONSUMABLE_VARIATIONS,
  CAT_TYPES,
  CAT_SAMPLE_CONDITIONS,
  CAT_FEATURES,
  CAT_EVENTS,
  CAT_EVENT_TYPES,
  CAT_EVENT_THEMES,
  CAT_ACTIVITY_SPHERES,
  CAT_INGREDIENT_CATEGORIES,
  CAT_USERS,
  CAT_RESEARCHES,
  CAT_PRODUCT_ORDERS,
  CAT_CUSTOMERS,
  CAT_PROJECTS,
  CAT_COURIER_DELIVERY_SERVICES,
  CAT_AGENTS,
  CAT_ORDER_AGENTS,
  CAT_RECOMMENDED_PRODUCTS,
  CAT_WEBSITE_DEALS,
  CAT_INFO_REQUESTS,
  CAT_WEBSITE_SERVICES,
  CAT_WEBSITES,
  CAT_STATUSES,
  CAT_ANALYZE_REQUESTS,
  CAT_AI_NEWS_PROMPTS,
  CAT_ATTENDING_REQUESTS,
  CAT_INFORMATION_SOURCES,
  CAT_INFORMATION_SOURCE_SNAPSHOTS,
  CAT_BRAND_STAFF_STATISTICS,
  CAT_BRAND_STAFF_ITEM_STATISTICS,
  CAT_COMPANY_STAFF_STATISTICS,
  CAT_COMPANY_STAFF_ITEM_STATISTICS,
  CAT_COMPONENTS_STAFF_STATISTICS,
  CAT_COMPONENTS_STAFF_ITEM_STATISTICS,
  CAT_CONTACT_STAFF_STATISTICS,
  CAT_CONTACT_STAFF_ITEM_STATISTICS,
  CAT_PATENT_STAFF_STATISTICS,
  CAT_PATENT_STAFF_ITEM_STATISTICS,
  CAT_PRODUCT_STAFF_STATISTICS,
  CAT_PRODUCT_STAFF_ITEM_STATISTICS,
  CAT_EVENT_STAFF_STATISTICS,
  CAT_EVENT_STAFF_ITEM_STATISTICS,
  CAT_NEWS_STAFF_STATISTICS,
  CAT_NEWS_STAFF_ITEM_STATISTICS,
  CAT_RESEARCHE_STAFF_STATISTICS,
  CAT_RESEARCHE_STAFF_ITEM_STATISTICS,
  CAT_PATENT_RESEARCH_STAFF_STATISTICS,
  CAT_PATENT_RESEARCH_STAFF_ITEM_STATISTICS,
  CAT_TRADEMARKS_STAFF_STATISTICS,
  CAT_TRADEMARKS_STAFF_ITEM_STATISTICS,
  CAT_COMPANY_NEWS,
  CAT_AI_NEWS,
  CAT_SOCIAL_MEDIA_SCRAPER_INSTAGRAM,
  CAT_SOCIAL_MEDIA_SCRAPER_FACEBOOK,
  CAT_SOCIAL_MEDIA_SCRAPER_X,
  CAT_SOCIAL_MEDIA_SCRAPER_YOUTUBE,
  CAT_SOCIAL_MEDIA_SCRAPER_LINKEDIN,
  CAT_SOCIAL_MEDIA_SCRAPER_ALL,
  CAT_SOCIAL_MEDIA_SCRAPER_CORE_ACCOUNTS,
  CAT_SOCIAL_MEDIA_SCRAPER_CORE_RESULTS,
  CAT_SOCIAL_MEDIA_SCRAPER_CORE_SESSIONS,
  CAT_NEWSLETTER_EMAILS,
  CAT_NEWSLETTER_DOMAINS,
  CAT_VARIATIONS,
} from 'App/constants/categories';

export const categories = new Set([CAT_CONTACTS, CAT_PATENTS, CAT_SAMPLES]);

export const searchEntities = new Set([
  CAT_PRODUCTS,
  CAT_BRANDS,
  CAT_CONTACTS,
  CAT_COMPANIES,
  CAT_TRADEMARKS,
  CAT_PATENTS,
]);

export const cmsCategories = new Set([
  CAT_PRODUCTS,
  CAT_STANDING_REPORTS,
  CAT_COMPANIES,
  CAT_BRANDS,
  CAT_PATENT_RESEARCH,
  CAT_TRADEMARKS,
  CAT_CONTACTS,
  CAT_COMPONENTS,
  CAT_SAMPLES,
  CAT_FILES,
  CAT_NEWS,
  CAT_CONSUMABLE_VARIATIONS,
  CAT_TYPES,
  CAT_SAMPLE_CONDITIONS,
  CAT_FEATURES,
  CAT_EVENTS,
  CAT_EVENT_TYPES,
  CAT_EVENT_THEMES,
  CAT_ACTIVITY_SPHERES,
  CAT_INGREDIENT_CATEGORIES,
  CAT_USERS,
  CAT_RESEARCHES,
  CAT_PRODUCT_ORDERS,
  CAT_CUSTOMERS,
  CAT_PROJECTS,
  CAT_COURIER_DELIVERY_SERVICES,
  CAT_AGENTS,
  CAT_ORDER_AGENTS,
  CAT_RECOMMENDED_PRODUCTS,
  CAT_WEBSITE_DEALS,
  CAT_INFO_REQUESTS,
  CAT_WEBSITE_SERVICES,
  CAT_WEBSITES,
  CAT_STATUSES,
  CAT_ANALYZE_REQUESTS,
  CAT_AI_NEWS_PROMPTS,
  CAT_ATTENDING_REQUESTS,
  CAT_INFORMATION_SOURCES,
  CAT_INFORMATION_SOURCE_SNAPSHOTS,
  CAT_SOCIAL_MEDIA_SCRAPER_CORE_ACCOUNTS,
]);

export const STATS_CATEGORIES_MAP = {
  [CAT_BRANDS]: {
    id: CAT_BRAND_STAFF_STATISTICS,
    title: 'Brands',
    itemCat: CAT_BRAND_STAFF_ITEM_STATISTICS,
  },
  [CAT_COMPANIES]: {
    id: CAT_COMPANY_STAFF_STATISTICS,
    title: 'Companies',
    itemCat: CAT_COMPANY_STAFF_ITEM_STATISTICS,
  },
  [CAT_COMPONENTS]: {
    id: CAT_COMPONENTS_STAFF_STATISTICS,
    title: 'Components',
    itemCat: CAT_COMPONENTS_STAFF_ITEM_STATISTICS,
  },
  [CAT_CONTACTS]: {
    id: CAT_CONTACT_STAFF_STATISTICS,
    title: 'Contacts',
    itemCat: CAT_CONTACT_STAFF_ITEM_STATISTICS,
  },
  [CAT_PATENTS]: {
    id: CAT_PATENT_STAFF_STATISTICS,
    title: 'Patents',
    itemCat: CAT_PATENT_STAFF_ITEM_STATISTICS,
  },
  [CAT_PRODUCTS]: {
    id: CAT_PRODUCT_STAFF_STATISTICS,
    title: 'Products',
    itemCat: CAT_PRODUCT_STAFF_ITEM_STATISTICS,
  },
  [CAT_EVENTS]: {
    id: CAT_EVENT_STAFF_STATISTICS,
    title: 'Events',
    itemCat: CAT_EVENT_STAFF_ITEM_STATISTICS,
  },
  [CAT_NEWS]: {
    id: CAT_NEWS_STAFF_STATISTICS,
    title: 'News',
    itemCat: CAT_NEWS_STAFF_ITEM_STATISTICS,
  },
  [CAT_RESEARCHES]: {
    id: CAT_RESEARCHE_STAFF_STATISTICS,
    title: 'Research',
    itemCat: CAT_RESEARCHE_STAFF_ITEM_STATISTICS,
  },
  [CAT_PATENT_RESEARCH]: {
    id: CAT_PATENT_RESEARCH_STAFF_STATISTICS,
    title: 'Patent research',
    itemCat: CAT_PATENT_RESEARCH_STAFF_ITEM_STATISTICS,
  },
  [CAT_TRADEMARKS]: {
    id: CAT_TRADEMARKS_STAFF_STATISTICS,
    title: 'Trademarks',
    itemCat: CAT_TRADEMARKS_STAFF_ITEM_STATISTICS,
  },
};

/**
 *
 * @type {Map<string, string>}
 */
export const CATS_PATH_MAP = new Map([
  [CAT_BRANDS, '/api/brands'],
  [CAT_BRAND_STAFF_STATISTICS, '/api/brand_staff_statistics'],
  [CAT_COMPANIES, '/api/companies'],
  [CAT_COMPANY_STAFF_STATISTICS, '/api/company_staff_statistics'],
  [CAT_COMPONENTS, '/api/components'],
  [CAT_COMPONENTS_STAFF_STATISTICS, '/api/component_staff_statistics'],
  [CAT_CONTACTS, '/api/contacts'],
  [CAT_CONTACT_STAFF_STATISTICS, '/api/contact_staff_statistics'],
  [CAT_FILES, '/api/files'],
  [CAT_NEWS, '/api/news'],
  [CAT_COMPANY_NEWS, '/api/news'],
  [CAT_AI_NEWS, '/api/news'],
  [CAT_PATENTS, '/api/patents'],
  [CAT_PATENT_STAFF_STATISTICS, '/api/patent_staff_statistics'],
  [CAT_PRODUCTS, '/api/products'],
  [CAT_PRODUCT_STAFF_STATISTICS, '/api/product_staff_statistics'],
  [CAT_EVENT_STAFF_STATISTICS, '/api/event_staff_statistics'],
  [CAT_NEWS_STAFF_STATISTICS, '/api/news_staff_statistics'],
  [CAT_RESEARCHE_STAFF_STATISTICS, '/api/research_staff_statistics'],
  [CAT_STANDING_REPORTS, '/api/reports'],
  [CAT_TRADEMARKS, '/api/trademark_items'],
  [CAT_EVENTS, '/api/events'],
  [CAT_RESEARCHES, '/api/researches'],
  [CAT_SOCIAL_MEDIA_SCRAPER_INSTAGRAM, '/api/instagram/results'],
  [CAT_SOCIAL_MEDIA_SCRAPER_FACEBOOK, '/api/facebook/results'],
  [CAT_SOCIAL_MEDIA_SCRAPER_X, '/api/x/results'],
  [CAT_SOCIAL_MEDIA_SCRAPER_YOUTUBE, '/api/youtube/results'],
  [CAT_SOCIAL_MEDIA_SCRAPER_LINKEDIN, '/api/linkedin/results'],
  [CAT_SOCIAL_MEDIA_SCRAPER_ALL, '/api/all/results'],
  [CAT_SOCIAL_MEDIA_SCRAPER_CORE_ACCOUNTS, '/api/core-accounts'],
  [CAT_SOCIAL_MEDIA_SCRAPER_CORE_RESULTS, '/api/core/results'],
  [CAT_SOCIAL_MEDIA_SCRAPER_CORE_SESSIONS, '/api/core/sessions'],
  [CAT_NEWSLETTER_EMAILS, '/api/messages'],
  [CAT_NEWSLETTER_DOMAINS, '/api/domains'],
  [CAT_VARIATIONS, '/api/product_variations'],
  [CAT_INFORMATION_SOURCES, '/api/information_sources'],
  [CAT_INFORMATION_SOURCE_SNAPSHOTS, '/api/information_source_snapshots'],
  [CAT_PATENT_RESEARCH_STAFF_STATISTICS, '/api/patent_research_staff_statistics'],
  [CAT_TRADEMARKS_STAFF_STATISTICS, '/api/trademark_staff_item_statistics'],
]);

export const TRACK_SESSION_TIME_CATS = new Set([
  CAT_BRANDS,
  CAT_COMPANIES,
  CAT_COMPONENTS,
  CAT_CONTACTS,
  CAT_PRODUCTS,
  CAT_FILES,
  CAT_TRADEMARKS,
  CAT_NEWS,
  CAT_EVENTS,
  CAT_RESEARCHES,
  CAT_PATENT_RESEARCH,
]);

export const NO_STANDING_REPORTS = [
  CAT_BRANDS,
  CAT_PATENTS,
  CAT_TRADEMARKS,
  CAT_CONTACTS,
  CAT_COMPANY_NEWS,
  CAT_STANDING_REPORTS,
  CAT_AI_NEWS,
  CAT_VARIATIONS,
];
